import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import "./map-vender.scss";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import Notfound from "@components/Not-Found-small";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import {
	clientGetFunction,
	clientGetLocation,
} from "@services/location.service";
import Loader from "@components/common/Loader";
import { NavLink } from "react-router-dom";
import { months } from "@_common/month";
import { years } from "@_common/year";
import InputField from "@_common/InputRuleFeild";
import { CreateCheckpointPECompliance } from "@services/checkpoint.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import PaginationPage from "@components/pagination/pagination";

export default function AssignToPECompliance(props: any) {
	let params = useParams();
	let navigate = useNavigate();

	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */

	const [activeTab, setActiveTab] = useState(1);
	const [locationList, setLocationList] = useState([]);
	const [vendorsList, setVendorsList] = useState([]);
	const [subVendorList, setSubVendorList] = useState([]);

	const [functions, setFunctions] = useState([]);

	const [selectedLocation, setSelectedLocation] = useState<any>({});
	const [selectedVendor, setSelectedVendor] = useState<any>([]);
	const [selectedSubVendor, setSelectedSubVendor] = useState<any>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [isLoading1, setIsLoading1] = useState(false);

	const [submitLoading, setSubmitLoading] = useState(false);

	const [month, setMonth] = useState<string | number | any>("");
	const [year, setYear] = useState<string | number | any>("");



	const [location_page_no, setLocationPageNo] = useState<any>(1);
	const [location_page_limit, setLocationPageLimit] = useState(10);
	const [location_total_count, setLocationTotalCount] = useState(0);

	const handleLocationPagination = (page_no: string) => {
		setLocationPageNo(page_no);
		getLocations(page_no);
	};

	const [function_page_no, setFunctionPageNo] = useState<any>(1);
	const [function_page_limit, setFunctionLimit] = useState(10);
	const [function_total_count, setFunctionTotalCount] = useState(0);

	const handleFunctionPagination = (page_no: string) => {
		setFunctionPageNo(page_no);
		getFunctions(currentLocation,page_no);
	};

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		var date = new Date();
		if(props.permissionAPITriggered){
		getLocations(location_page_no);
		}
		// getFunctions();
		setMonth(date.getMonth() + 2);
		setYear(date.getFullYear());
	}, [props.permissionAPITriggered]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const getLocations = async (page_no:any) => {
		try {
			let payload: any = {
				page_no: page_no,
				page_size: location_page_limit,
				is_active:true
			};
			let queryRequest = QueryRequestHelper(payload);
			setIsLoading(true);
			let resp = await clientGetLocation(queryRequest);
			if (resp) {
				setLocationTotalCount(getValue(resp, `data.pagination.total`, 0));
				let filtered = getValue(resp, `data.locations`, []).filter(
					(item: object) => getValue(item, `is_active`, false)
				);

				setLocationList(
					getValue(filtered, `length`, 0) > 0 &&
						filtered.map((item: object) => ({
							...item,
							status: getValue(item, `is_active`, false)
								? "Active"
								: "Inactive",
							city_name: getValue(item, `city.name`, ""),
							value: getValue(item, `location_name`, ""),
							label: getValue(item, `location_name`, ""),
						}))
				);
				selectedLocation.push(getValue(filtered, `[${0}].id`, ""));
				getFunctions(getValue(filtered, `[${0}].id`, ""),function_page_no);
				setCurrentLocation(getValue(filtered, `[${0}].id`, ""));
				setIsLoading(false);
				
			} else {
				setIsLoading(false);
				
			}
		} catch (error) {
			setIsLoading(false);
			
		}
	};

	const getFunctions = async (id: string,page_no:string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
			page_no: page_no,
			page_size: function_page_limit,
			location_id: id,
		};
		let queryRequest = QueryRequestHelper(payload);
		setIsLoading1(true);
		try {
			let resp = await clientGetFunction(queryRequest);
			if (resp) {
				setFunctions(getValue(resp, `data.functions`, []));
				setFunctionTotalCount(getValue(resp, `data.pagination.total`, 0));
				setIsLoading1(false);
			} else {
				setIsLoading1(false);
			}
		} catch (error) {}
	};

	const handleSubmit = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
		try {
			if (Object.keys(selectedLocation).length > 0) {
				let payload = {
					checkpoint_ids: selectedIDs,
					assign_values: Object.entries(selectedLocation).map(
						(loc: any, _index) => ({
							location_id: loc[0],
							function_ids: loc[1],
						})
					),
				};
				let checkEmpty = getValue(payload, `assign_values`, []).filter(
					(item: any) => getValue(item, `function_ids.length`, 0) > 0
				);

				if (getValue(checkEmpty, `length`, 0) > 0) {
					if (selectedIDs.length > 0) {
						setSubmitLoading(true);
						let resp = await CreateCheckpointPECompliance({
							checkpoint_ids: payload.checkpoint_ids,
							assign_values: checkEmpty,
						});
						if (resp) {
							setSubmitLoading(false);
							toast.success(getValue(resp, `message`, ""));
							navigate(`/repository/checkpoint/PE-compliance`);
						} else {
							setSubmitLoading(false);
						}
					} else {
						setSubmitLoading(false);
						toast.error("All fields are mandatory");
					}
				} else {
					toast.error("Please select fuction");
				}
			} else {
				setSubmitLoading(false);
				toast.error("All fields are mandatory");
			}
		} catch (error) {
			setSubmitLoading(false);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const [all, setAll] = useState("false");
	const handleChangeAllVendor = (value: string) => {
		setAll(value);
		if (value === "true") {
			let list = subVendorList.map((item: object) => getValue(item, `id`, ""));
			setSelectedSubVendor(list);
		} else {
			setSelectedSubVendor([]);
		}
	};

	const [currentLocation, setCurrentLocation] = useState("");
	const handleSelectLocation = async (id: string) => {
		getFunctions(id,function_page_no);
		setCurrentLocation(id);
		if (Object.keys(selectedLocation).includes(id)) {
			// delete selectedLocation[id];
			// setSelectedLocation({ ...selectedLocation });
		} else {
			selectedLocation[id] = [];
			setSelectedLocation({ ...selectedLocation });
		}
		setSubVendorList([]);
		// let selectedLocations = selectedLocation.filter(
		// 	(item: string) => item === id
		// );
		// if (selectedLocations.length > 0) {
		// 	let filtered = selectedLocation.filter((item: string) => item !== id);
		// 	setSelectedLocation(filtered);
		// } else {
		// 	selectedLocation.push(id);
		// 	setSelectedLocation([...selectedLocation]);
		// }
	};

	const handleSelectLocationOnClick = async (id: string) => {
		getFunctions(id,function_page_no);
		setCurrentLocation(id);
	};

	const handleSelectSubVendor = (id: string) => {
		if (Object.keys(selectedLocation).length > 0) {
			let selectedSubVendors = selectedLocation[currentLocation].filter(
				(item: string) => item === id
			);
			if (selectedSubVendors.length > 0) {
				let filtered = selectedLocation[currentLocation].filter(
					(item: string) => item !== id
				);
				selectedLocation[currentLocation] = filtered;
				setSelectedLocation({ ...selectedLocation });
			} else {
				selectedLocation[currentLocation].push(id);
				setSelectedLocation({ ...selectedLocation });
			}
		} else {
			toast.error("Please select location");
		}
	};

	const urlSearchParams = new URLSearchParams(window.location.search);
	let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
	

	return (
		<>
			<Layout>
				{!isLoading &&
				!getValue(props, `subTabPermissionList`, []).includes(
					"repository_checkpoint_pe_compliance"
				) ? (
					<NoAccessPage />
				) : (
					<>
						<div className="common-sticky-header">
							<section className="inner-page-navigation-with-back-cta-buttons position-relative">
								<div className="container-fluid  d-flex justify-content-between align-items-center">
									<div className="d-flex align-items-center">
										<NavLink to="/repository/checkpoint/master">
											<img
												src="/images/back-link.svg"
												className="img-fluid"
												height={24}
												width={24}
											/>
										</NavLink>
										<p className="inner-page-navigation-text py-3">
											Assign to PE
										</p>
									</div>
								</div>
							</section>
						</div>
						<div className="release-checkpoint  d-flex justify-content-between align-items-center">
							<h4>Selected {getValue(selectedIDs, `length`, 0)} Checkpoints</h4>
							{getValue(props, `permissions`, []).includes("update") && (
								<div>
									{submitLoading ? (
										<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
											Please wait...
										</button>
									) : (
										<button
											className="ascent-button ascent-button--header-buttons ascent-button--secondary"
											onClick={handleSubmit}
										>
											Assign
										</button>
									)}
								</div>
							)}
						</div>
						{activeTab === 1 ? (
							<>
								{/* Location */}
								<div className="map-vendor-wrapper w-100">
									<div className="map-vendor__details d-flex align-items-flex-start m-0">
										<div className="map-vendor__check">
											<div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
												<h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
													Location Name
												</h5>
												<div className="form-group d-flex align-iems-center m-0"></div>
											</div>
											<div className="map-vendor__checklist my-3">
												{isLoading || !props.permissionAPITriggered ? (
													<Loader />
												) : getValue(locationList, `length`, 0) > 0 ? (
													locationList.map((searchObj, index) => {
														return (
															<>
																<div
																	className={`release-details d-flex cursor-pointer
														${
															currentLocation === getValue(searchObj, `id`, "")
																? "background_selected"
																: ""
														}
														`}
																	onClick={() =>
																		handleSelectLocation(
																			getValue(searchObj, `id`, "")
																		)
																	}
																>
																	<label
																		className="position-relative form-group d-flex align-items-center cursor-pointer mb-0"
																		htmlFor={`location-${index}`}
																		key={`location-${index}`}
																	>
																		<div>
																			<input
																				type="radio"
																				className="new-radio"
																				// className="default-checkbox cursor-pointer"
																				id={`location-${index}`}
																				// checked={Object.keys(
																				// 	selectedLocation
																				// ).includes(getValue(searchObj, `id`, ""))}
																				checked={
																					currentLocation ===
																					getValue(searchObj, `id`, "")
																				}
																				onChange={() =>
																					handleSelectLocation(
																						getValue(searchObj, `id`, "")
																					)
																				}
																			/>
																			{/* <div className="custom-checkbox">
																		<img
																			src="/images/uploaded-details/tick.svg"
																			className="img-fluid uploaded-tick"
																		/>
																	</div> */}
																			{/* <div className="custom-radio--bg-red">
																		<img
																			src="/images/uploaded-details/tick.svg"
																			className="img-fluid uploaded-tick"
																		/>
																	</div> */}
																		</div>
																		<div
																			className="cursor-pointer"
																			// onClick={() =>
																			// 	handleSelectLocation(
																			// 		getValue(searchObj, `id`, "")
																			// 	)
																			// }
																		>
																			<p
																				className="mx-3"
																				onClick={() =>
																					handleSelectLocation(
																						getValue(searchObj, `id`, "")
																					)
																				}
																			>
																				{" "}
																				{getValue(
																					searchObj,
																					`location_name`,
																					""
																				)}
																			</p>
																			<div className="mx-3">
																				{getValue(
																					selectedLocation,
																					`[${getValue(
																						searchObj,
																						`id`,
																						""
																					)}].length`,
																					0
																				)}{" "}
																				Functions selected
																			</div>
																		</div>
																	</label>
																</div>
															</>
														);
													})
												) : (
													<>
														{Object.keys(params).length !== 0 ? (
															<>
																<Notfound />
															</>
														) : (
															<Notfound />
														)}
													</>
												)}
												{location_total_count > 10 ? (
													<PaginationPage
														totalCount={location_total_count}
														limit={location_page_limit}
														pageNumber={location_page_no}
														handleChangePagination={handleLocationPagination}
														showLimit={"false"}
														// handleChangeLimit={handleChangeLimit}
													/>
												) : (
													<p className="show-rows-count mt-3 d-flex">
														Total Count:&nbsp;&nbsp;{" "}
														<p style={{ color: "rgb(13, 110, 253)" }}>
															{location_total_count}
														</p>
													</p>
												)}
											</div>
										</div>
										{/* Function */}
										<div className="map-vendor__check">
											<div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
												<h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
													Function Name
												</h5>
												<div className="form-group d-flex align-iems-center m-0"></div>
											</div>
											<div className="map-vendor__checklist my-3">
												{isLoading1 || !props.permissionAPITriggered ? (
													<Loader />
												) : getValue(functions, `length`, 0) > 0 ? (
													functions.map((searchObj, index) => {
														return (
															<div className="release-details d-flex">
																<label
																	className="position-relative form-group d-flex align-items-center cursor-pointer mb-0"
																	htmlFor={`vendor-${index}`}
																	key={`vendor-${index}`}
																>
																	<div>
																		<input
																			type="checkbox"
																			className="default-checkbox"
																			id={`vendor-${index}`}
																			checked={
																				getValue(
																					selectedLocation,
																					`[${currentLocation}].length`,
																					0
																				) > 0 &&
																				selectedLocation[
																					currentLocation
																				].includes(
																					getValue(searchObj, `id`, "")
																				)
																			}
																			onChange={() =>
																				handleSelectSubVendor(
																					getValue(searchObj, `id`, "")
																				)
																			}
																		/>
																		<div className="custom-checkbox--bg-red">
																			<img
																				src="/images/uploaded-details/tick.svg"
																				className="img-fluid uploaded-tick"
																			/>
																		</div>
																	</div>
																</label>
																<div
																	className=" d-flex cursor-pointer"
																	onClick={() =>
																		handleSelectSubVendor(
																			getValue(searchObj, `id`, "")
																		)
																	}
																>
																	<p
																		className="mx-3"
																		// onClick={() =>
																		// 	getSubVendor(getValue(searchObj, `id`, ""))
																		// }
																	>
																		{" "}
																		{getValue(searchObj, `function_name`, "")}
																		{" - "}
																		{getValue(searchObj, `unit_name`, "")}
																	</p>
																</div>
															</div>
														);
													})
												) : (
													<>
														{Object.keys(params).length !== 0 ? (
															<>
																<Notfound />
															</>
														) : (
															<Notfound />
														)}
													</>
												)}
												{function_total_count > 10 ? (
													<PaginationPage
														totalCount={function_total_count}
														limit={function_page_limit}
														pageNumber={function_page_no}
														handleChangePagination={handleFunctionPagination}
														showLimit={"false"}
														// handleChangeLimit={handleChangeLimit}
													/>
												) : (
													<p className="show-rows-count mt-3 d-flex">
														Total Count:&nbsp;&nbsp;{" "}
														<p style={{ color: "rgb(13, 110, 253)" }}>
															{function_total_count}
														</p>
													</p>
												)}
											</div>
										</div>
									</div>
									<div className="footer-wrapper-new w-100">
										<img
											src="/images/footer-image.svg"
											className="img-fluid footer-image"
										/>
									</div>
								</div>
							</>
						) : (
							<div className="user-details-wrapper m-0">
								<div className="checkpoint-active-details-wrapper__form-wrapper">
									<div className="checkpoint-active-details-wrapper__form-content">
										<Row>
											<Col md="6">
												<div className="user-details-wrapper__form-group form-group">
													<label className="checkpoint-active-details__label">
														Month
													</label>
													<InputField
														inputType="INPUT_REACT_SELECT"
														placeholder="Choose Month"
														className="users-form-control"
														name="month"
														id="month"
														options={months}
														value={months.filter(
															(item: object) =>
																getValue(item, `value`, "") == month
														)}
														onChange={(e: any) => setMonth(e.value)}
														label="Month"
														// validator={simpleValidator}
													/>
												</div>
											</Col>
											<Col md="6">
												<div className="user-details-wrapper__form-group form-group">
													<label className="checkpoint-active-details__label">
														Year
													</label>
													<InputField
														inputType="INPUT_REACT_SELECT"
														placeholder="Choose Month"
														className="users-form-control"
														name="month"
														id="month"
														options={years}
														value={years.filter(
															(item: object) =>
																getValue(item, `value`, "") == year
														)}
														onChange={(e: any) => setYear(e.value)}
														label="Year"
														// validator={simpleValidator}
													/>
												</div>
											</Col>
										</Row>
									</div>
								</div>
							</div>
						)}
					</>
				)}
			</Layout>
		</>
	);
}
